import { createContext, useContext } from 'react';

export type CommandPaletteContextType = {
  isOpen: boolean;
  onHide: () => void;
  onShow: () => void;
};

export const CommandPaletteContext = createContext<CommandPaletteContextType>({
  isOpen: false,
  onHide: () => {},
  onShow: () => {},
});

export const useCommandPaletteContext = () => useContext<CommandPaletteContextType>(CommandPaletteContext);
